export const SHAREPOINT_CONFIG = {
  TENANT_ID: "7d321551-3194-4faa-9a47-31168e602900",
  APPLICATION_ID: "1184a414-711e-4122-b6f4-7385101a4f26",
  CLIENT_SECRET: "r_J8Q~GznWLaAxKcJJWjUjlnLW2pW89j19bjvbop",
  REDIRECT_URI: "http://localhost:3000/home",
  // Use delegated scopes for SharePoint/Graph access in SPA
  SCOPES: "Files.Read.All Sites.Read.All",
  // Use organizations to allow any work/school account in any tenant
  AUTHORITY: `https://login.microsoftonline.com/organizations/`,
  AUTH_URI: `https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize`,
  TOKEN_URI: `https://login.microsoftonline.com/organizations/oauth2/v2.0/token`,
  GRAPH_API_BASE: "https://graph.microsoft.com/v1.0",
};

export default SHAREPOINT_CONFIG;
